<template>
  <header class="header">
    <section class="logo-menu">
      <div class="container-fluid">
        <div class="columns is-mobile is-multiline is-centered">
          <div class="column is-12-mobile is-6-desktop has-text-left">
            <figure class="logo-container">
              <a href="https://www.osfatun.com.ar/" target="_blank"
                ><img
                  src="./../../assets/osfatunblanco-30.svg"
                  srcset="
                    ./../../assets/osfatunblanco-30.svg     1x,
                    ./../../assets/osfatunblanco-30.svg 2x
                  "
                  width="220px"
                  alt="osfatun"
              /></a>
            </figure>
          </div>
          <div class="column is-12-mobileis-6-desktop has-text-right">
            <ul class="menu" id="menu-responsive">
              <li v-for="item in data.menu" :key="item.k">
                <template v-if="item.type == 'to'">
                  <router-link :to="item.to">{{ item.text }}</router-link>
                </template>
                <template v-if="item.type == 'href'">
                  <a :href="item.href">
                    <span class="is-hidden-mobile">|</span>&nbsp;&nbsp;
                    {{ item.text }}
                  </a>
                </template>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <figure class="sentence">
      <img

        src="./../../assets/cuotas-y-minimos.svg"
        width="800px"
        alt="osfatun"
      />

    </figure>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: ["data"],
};
</script>

<style scoped>
.sentence {
  max-width: 44%;
  margin: 0 auto;
  margin-bottom: 0;
  margin-top: 70px;
}
.header {
  background-image: url("./../../assets/fondo-header.png");
  background-size: 100%;
  width: 100%;
  height: 80vh;
  background-repeat: no-repeat;
}
.logo-menu {
  max-width: 83%;
  margin: 0px auto;
  padding-top: 6%;
}
.menu {
  list-style: none;
}
.menu li {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  color: #fff;
  text-transform: uppercase;
}
.menu li a {
  color: #fff;
  font-weight: bold;
  font-size: 18px;
}
.menu li:hover a,
.menu li.current-menu-item a {
  color: #fff;
  filter: drop-shadow(3px 4px 4px black);
}
.menu li:last-child {
  border-right: 0;
  margin-right: 0;
  padding-right: 0;
}
@media screen and (max-width: 480px) {
  .logo-container {
    text-align: center;
  }
  .logo-container img {
    width: 150px;
  }
  .logo-menu {
    padding-top: 3%;
  }
  .menu {
    display: none;
  }
  .header {
    background-image: url("./../../assets/fondo-header-responsive.png");
    background-size: 100%;
    height: 30vh;
    background-repeat: no-repeat;
  }
  .sentence {
    margin-top: 0;
    max-width: 84%;
  }
}
</style>
